<script lang="ts">
    import FaqItem from "../Elements/FaqItem.svelte";

    export let section: Section;
    export let index: number;
</script>

<div class="bg-white">
    <div class="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8 lg:py-40">
        <div class="mx-auto max-w-4xl divide-y divide-gray-900/10">
            <div>
                <h2 class="text-2xl font-bold leading-10 tracking-tight text-gray-900">
                    {section.title}
                </h2>
                <p class="mt-6 max-w-2xl text-base leading-7 text-gray-900">
                    {section.description}
                </p>
            </div>

            <dl class="mt-10 space-y-6 divide-y divide-gray-900/10">
                {#each section.blocks as block}
                    <FaqItem title={block.title} description={block.description} />
                {/each}
            </dl>
        </div>
    </div>
</div>
